<div class="betslip-edit-bet__add-selection betslip-edit-bet_add-button-container">
    <button
        ds-button
        msThemedButton
        kind="secondary"
        variant="outline"
        size="medium"
        [themeKind]="buttonThemeKind"
        [disabled]="isButtonDisabled"
        (click)="addSelection()">
        <vn-icon slot="start" name="theme-plus" size="12"></vn-icon>
        {{ siteCore.betslip.editBet.addSelection }}
    </button>
</div>
